export default function userReducer(userContext, action){
	switch (action.type) {
    case 'update': {
      return {
        ...action.user,
      }
    }
    default: {
      throw Error('Unknown user action: ' + action.type);
    }
  }
}